import React from 'react';
import { PixeledLoader, ComfortaaLoader } from './style.js';

// FontLoader: use this component to pre-load fonts in a background div so PIXI
//             can access them when needed

class FontLoader extends React.Component {
  render() {
    return (
      <div>
        <PixeledLoader>.</PixeledLoader>
        <ComfortaaLoader>.</ComfortaaLoader>
      </div>
    );
  }
}

export default FontLoader;
